// 会员活动页接口
const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const CPAPI = `//m-cpapi${spell}.xinli001.com/cp/service/`,
  HCP = `//hcp${spell}.xinli001.com/`,
  LXDOMAIN = spell ? `//lingxi${spell}.xinli001.com/lingxi/service/` : `//m-lingxi${spell}.xinli001.com/lingxi/service/`,
  APIS = {
		friendCardMyInvite: `${LXDOMAIN}friendCard/myInvite`, //  亲友卡我的邀请记录
		friendCardRank: `${LXDOMAIN}friendCard/rank`, //  亲友卡排行榜
		friendReceive: `${LXDOMAIN}friendCard/receive`, //  亲友卡领取接口
		consultBindPhone: `${LXDOMAIN}consult/bindPhone`, //  绑定此刻心理手机号
		phoneStatusAndAutoBind: `${LXDOMAIN}consult/phoneStatusAndAutoBind`, //  绑定此刻心理手机号
		friendCardReceiveStatus: `${LXDOMAIN}friendCard/receiveStatus`, //  绑定此刻心理手机号

  }

export default APIS



// WEBPACK FOOTER //
// ./src/apis/member.js